import React, {useCallback} from "react";
import { useRegionsQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import {GraphQlSelect} from "./GraphQlSelect";



export function RegionSelect(props) {
    const query = useRegionsQueryQuery({variables:{regionTypeId:props.regionType??null}});
    const filterOptions = useCallback((options) => {
        const newOptions = [];
        options.forEach((region) => {
                if(props.areaOnly) {
                    if(!region.is_area_booking) return;
                }
                if(props.panelOnly) {
                    if(!region.is_panel_booking) return;
                }
                newOptions.push(region);
            }
        );
        return newOptions;
    }, []);
    return props.valueIsId?<GraphQlSelectId gqlVariables={{regionTypeId: props.regionType}} filterOptions={filterOptions} queryResult={query} {...props}  labelField="name" />
    :<GraphQlSelect gqlVariables={{regionTypeId: props.regionType}} queryResult={query} filterOptions={filterOptions} {...props}  labelField="name" />;
}

